export function Exception(message) {
    this.message = message;
}

export function InvalidArgumentException(message) {
    this.message = message;
}
